// Global packages and components
import { Button, Modal, Heading } from '~/components'

// Types
interface Props {
  open: boolean
  setOpen: (e: boolean) => void
  onClose: () => void
  onProgress: () => void
}

// Main export
const CheckAddressModal = ({ open, setOpen, onClose, onProgress }: Props) => (
  <Modal
    size="sm"
    open={open}
    setOpen={setOpen}
    onClose={onClose}
  >
    <Heading
      tag="h3"
      size="h5"
    >
      Delivery address
    </Heading>
    <p>
      By using this new delivery address, all items in your basket will be
      updated. Would you like to proceed?
    </p>
    <Button
      title="Yes, update my address"
      style="tealGreen"
      fullWidth
      onClick={onProgress}
    />
  </Modal>
)

export default CheckAddressModal
